
const digest = 'ed563997da82c79111c7a75925e41b8dd16a3ce062c607bc51e099d075b6b568';
const classes = {"wrapper":"_wrapper_1jpdv_1","addressContainer":"_addressContainer_1jpdv_4","title":"_title_1jpdv_17"};
const css = `._wrapper_1jpdv_1 {
  font-family: Rubik, "sans-serif";
}
._wrapper_1jpdv_1 ._addressContainer_1jpdv_4 {
  padding: 40px 50px;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  border: 1px solid #e2e5ed;
  border-radius: 20px;
  width: fit-content;
  box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.1);
}
._wrapper_1jpdv_1 ._addressContainer_1jpdv_4 ._title_1jpdv_17 {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
}
._wrapper_1jpdv_1 ._addressContainer_1jpdv_4 span {
  font-weight: 500;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  